import { useState, useEffect } from 'react';
import { Share, X, PlusSquare } from 'lucide-react';
import { isIos, isStandalone } from '../lib/push';
import { useLanguage } from '../contexts/LanguageContext';

const DISMISS_KEY = 'flowupy_ios_install_banner_dismissed';

const STR = {
  tr: {
    title: 'Bildirimler için önemli',
    desc: 'iPhone/iPad cihazlarda bildirim alabilmeniz için FlowUpy uygulamasını Ana Ekranınıza eklemeniz gerekiyor. Tarayıcı sekmesinde push bildirimleri Apple tarafından engelleniyor.',
    share: 'Paylaş', add: 'Ana Ekrana Ekle', close: 'Kapat',
  },
  en: {
    title: 'Important for notifications',
    desc: 'On iPhone/iPad, you must add the FlowUpy app to your Home Screen to receive notifications. Push notifications in a browser tab are blocked by Apple.',
    share: 'Share', add: 'Add to Home Screen', close: 'Close',
  },
};

/**
 * One-time onboarding banner telling iOS users to add FlowUpy to their Home
 * Screen. Push on iOS only works for installed PWAs.
 */
export const IosInstallBanner = () => {
  const { language } = useLanguage();
  const L = STR[language] || STR.tr;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY) === 'true';
    if (isIos() && !isStandalone() && !dismissed) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg p-4"
      data-testid="ios-install-banner"
    >
      <div className="max-w-lg mx-auto flex items-start gap-3">
        <div className="flex-1 text-sm">
          <p className="font-semibold mb-1">{L.title}</p>
          <p className="text-muted-foreground">
            {L.desc}
          </p>
          <div className="flex items-center gap-2 mt-2 text-sm flex-wrap">
            <span className="inline-flex items-center gap-1 bg-muted px-2 py-1 rounded">
              <Share className="w-4 h-4" /> {L.share}
            </span>
            <span>→</span>
            <span className="inline-flex items-center gap-1 bg-muted px-2 py-1 rounded">
              <PlusSquare className="w-4 h-4" /> {L.add}
            </span>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="p-1 text-muted-foreground hover:text-foreground"
          data-testid="ios-install-banner-dismiss"
          aria-label={L.close}
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default IosInstallBanner;
